import React, { FC, memo, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, MenuProps } from 'antd';
import classNames from 'classnames';
import { fetchItems } from '@core/utils/methods';
import { RouteGroup } from '@models/classes';
import { MenuPlacement } from '@models/enums';
import { MenuGroup, MenuItem } from '@models/types';

import './styles.scss';

const SideMenuComponent: FC = () => {
  const [menuItems, setMenu] = useState<MenuGroup>([]);
  const { pathname } = useLocation();

  useEffect(() => {
    fetchItems(MenuPlacement.Main).then((menu: MenuGroup) => setMenu(menu));
  }, []);

  const items: MenuProps['items'] = menuItems?.map(
    ([item, submenu]: MenuItem[]) => {
      const menuItem = item as RouteGroup;
      const submenuItems = submenu as RouteGroup[];

      return {
        key: menuItem.path,
        popupClassName: 'side__submenu-popup',
        className: classNames({
          'menu-item-selected': !!menuItem.findRouteByPath(pathname),
        }),
        label: (
          <span className="side__icon-box">
            {menuItem.icon &&
              React.createElement(menuItem.icon, {
                className: 'side__icon',
              })}
            <span className="side__title">{menuItem.name}</span>
          </span>
        ),
        children: submenuItems.map((submenuItem: RouteGroup) => ({
          key: submenuItem.path,
          className: classNames(
            {
              'menu-item-selected': !!submenuItem.findRouteByPath(pathname),
            },
            'side__submenu-item',
          ),
          label: <Link to={submenuItem.path}>{submenuItem.name}</Link>,
        })),
      };
    },
  );

  return <Menu mode="inline" className="side" items={items} />;
};

export const SideMenu: FC = memo(SideMenuComponent);
